<!-- /parent/selfcheckout
parent self checkout -->

<template>
  <CContainer fluid>
    <CRow class="justify-content-center" style="margin-top:50px" >
      <CCol lg="12" >
          <div class="card">
            <div class="card-body">
              <b><h3> PARENT SELF CHECKOUT </h3></b>
                <h5 style="color:grey;">SCAN YOUR KID QR CODE TO CHECK OUT</h5>
              <CRow class="mt-3">
                <CCol sm="9" >
                  <b-input
                    placeholder="If the QR Code is not working, please click here then scan again."
                    ref="text"
                    v-model="form.value"
                    id="feedback-user"
                    class="mb-1"
                    @input="changeHandler"
                    @blur.prevent="focusTextbox"
                    autofocus
                  >
                  </b-input>
                </CCol>
                <CCol  >
                  <CButton  sm="12" md="6" class="buttons-row mb-3 d-flex justify-content-center" block color="info" @click="scan">Scan</CButton>
                  <alertmodal></alertmodal>
                </CCol>
                <CCol>
                  <CButton sm="12" md="6" class="buttons-row mb-3 d-flex justify-content-center" block color="warning" @click="clearPage">Clear</CButton>
                </CCol>
              </CRow>
              <strong id="error"></strong>
            </div>
          </div>
        </CCol>
    </CRow>
    <CRow class="justify-content-between mb-3" v-if="data.length > 0" >
      <CCol lg="3" >
      <CRow v-if="selectedItems.length > 0">
        <CCol>
          <CButton block @click=" openQueueAll(selectedItems)"  variant="primary" color="danger">Checkout</CButton>
        </CCol>
      </CRow>
      </CCol>
        <CCol lg="3">
          <CRow>
        <CCol>
          <CButton block @click=" openSelectAll()"  variant="primary" color="primary">Select All</CButton>
        </CCol>
        <CCol>
          <CButton block @click=" selectedItems = []"  variant="primary" color="primary">Unselect All</CButton>
        </CCol>
      </CRow>
      </CCol>
    </CRow>
        <CRow lg="12">
          <CCol lg="4" v-for="item in data" :key="item.id" >
              <CCard class="card-kids" :class="{selected: isSelected(item.id), disabled: isDisabled(item.checkin_status)}" @click="handleSelect(item)">
                <CRow>
                  <CCol  >
                    <CCardBody>
                      <CRow>
                        <img v-bind:src="getPhoto(item.get_photo)" class="c-avatar-img-scan justify-content-start"  >
                          <CCol>
                            <CCallout v-if="item.checkin_status && item.checkin_status.action == 'in class'" color="success">
                              <CRow class="justify content between">
                            <CCol>
                            <h5><CBadge v-if="item.checkin_status  && item.checkin_status.action == 'in class'" color="success">In Class</CBadge></h5>
                          </CCol>
                            <CCol sm="12">
                            <p> Name: <b> {{item.firstname + " " + item.lastname}} </b></p>
                            <p> Gender: <b>{{item.sex}}</b> </p>
                            <p> Class: <b>{{item.ikid_class.name}} </b> </p>

                            <p v-if="item.dad_people_uuid && !item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname }}</b>
                            </p>
                            <p v-else-if="!item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            <p v-else-if="item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname + ' and ' + item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            </CCol>
                          </CRow>
                        </CCallout>
                        <CCallout v-else-if="item.checkin_status && item.checkin_status.action == 'queued'" color="secondary">
                          <CRow class="justify content between">
                            <CCol>
                            <h5><CBadge v-if="item.checkin_status && item.checkin_status.action == 'queued'" color="secondary">In Queued</CBadge></h5>
                          </CCol>
                            <CCol sm="12">
                            <p> Name: <b> {{item.firstname + " " + item.lastname}} </b></p>
                            <p> Gender: <b>{{item.sex}}</b> </p>
                            <p> Class: <b>{{item.ikid_class.name}} </b> </p>

                            <p v-if="item.dad_people_uuid && !item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname }}</b>
                            </p>
                            <p v-else-if="!item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            <p v-else-if="item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname + ' and ' + item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            </CCol>
                          </CRow>
                        </CCallout>
                        <CCallout v-else="item.checkin_status && item.checkin_status.action == 'check out'" color="danger">
                          <CRow class="justify content between">
                            <CCol>
                            <h5><CBadge v-if="item.checkin_status && item.checkin_status.action == 'check out'" color="danger">Check out</CBadge></h5>
                          </CCol>
                            <CCol sm="12">
                            <p> Name: <b> {{item.firstname + " " + item.lastname}} </b></p>
                            <p> Gender: <b>{{item.sex}}</b> </p>
                            <p> Class: <b>{{item.ikid_class.name}} </b> </p>

                            <p v-if="item.dad_people_uuid && !item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname }}</b>
                            </p>
                            <p v-else-if="!item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            <p v-else-if="item.dad_people_uuid && item.mom_people_uuid">
                              Parents: <b>{{ item.dad.firstname + ' ' + item.dad.lastname + ' and ' + item.mom.firstname + ' ' + item.mom.lastname }}</b>
                            </p>
                            </CCol>
                          </CRow>
                        </CCallout>

                          <!-- <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" block @click=" openCheckOut(item.id)"  variant="primary" color="warning">Check Out</CButton> -->
                          <!-- <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" block @click=" openQueue(item.id)"  variant="primary" color="warning">Check Out</CButton> -->
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCol>
              </CRow>
            </CCard>
          </CCol>
    </CRow>
    <ikidmodalcheckout></ikidmodalcheckout>
    <!-- <pre>{{ $data | json }}</pre> -->
  </CContainer>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

import axios from 'axios'
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';
import ikid from '@/services/ikid'
import ikidmodalcheckout from './kids_checkout.vue';
import { sendMessageToDiscord } from '@/discordUtils';


export default {

  components: { QrcodeStream, alertmodal,ikidmodalcheckout, },

  data () {
    return {
      data:[],
      id: '',
      class_id: [],
      class_name: [],
      dad_id: [],
      dad_name: [],
      mom_id:[],
      mom_name:[],
      selectedItems: [],
      form:{
        value: '',
        from:'portal',
      },
      value: '',
      error: '',
      camera_hide: false,
      result_hide: true,
      message: '',
      message_hide: true,
      loading_submit: false,
    }
  },

  created(){
      // ikid.getIkidClass().then(res => {
      //   for (let i = 0; i <= res.data.length - 1; i++) {
      //       this.class_id.push(res.data[i].id);
      //       this.class_name.push(res.data[i].name);
      //    }
      //   });
      //   ikid.getIkidParent().then(res => {
      //   for (let i = 0; i <= res.dad.length - 1; i++) {
      //     this.dad_id.push(res.dad[i].id);
      //     this.dad_name.push(res.dad[i].firstname + ' ' + res.dad[i].lastname);
      //    }
      //    for (let i = 0; i <= res.mom.length - 1; i++) {
      //     this.mom_id.push( res.mom[i].id);
      //     this.mom_name.push( res.mom[i].firstname + ' ' + res.mom[i].lastname);
      //    }
      //   });
  },

  mounted(){
    this.$refs.text.$el.focus();
      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
        this.scan();
      }
      });

      this.openSelectAll()

    // var self = this;
    // window.addEventListener('keyup', function(event) {
    //   if (event.keyCode === 13) {
    //     //alert('press enter')
    //     self.check123();
    //   }
    // });


  },

  methods: {
    scan: function () {
      // this.camera_hide = false;
      // this.result_hide = true;
      this.loading_submit = true
      var temp_input = this.form.value;
      var self = this;
        ikid.scanKidForParentPage({value:this.form.value})
        .then(res => {
            const newData = res.data.filter(i => {if (i.checkin_status && i.checkin_status.action == 'in class' ) return i})
            this.data = newData;
            this.id = res.data.id;
            this.camera_hide = true;
            this.result_hide = false;
            self.form.firstname = res.data[0].firstname;
            self.form.lastname = res.data[0].lastname;
            self.form.sex = res.data[0].sex;
            self.form.profilepic = res.data[0].profilepic;
            self.form.class_id = res.data[0].class_id;
            self.form.dad_id = res.data[0].dad_id;
            self.form.mom_id = res.data[0].mom_id;
            error.innerHTML = "<span style='color: green;'>"+
            "Success - Recorded KIDS Successfully</span>"
            this.selectedItems = newData.map(i => i.id)
            this.form.value = null
            this.loading_submit = false
            if (this.data.length == 0) {
              this.$refs.text.$el.focus();
            }

            // check qr valid
            var is_valid = false;
            for (let i = 0; i <= this.data.length - 1; i++) {
              if ((this.data[i].checkin_status !== null && (this.data[i].checkin_status.action == 'in class'))) {
                is_valid = true;
                break;
              }
              if (is_valid) {
                break;
              }
            }
            if (!is_valid) {
              error.innerHTML = "<span style='color: red;'>"+
              "Invalid QR Code.</span>"
              this.camera_hide = true;
              this.form.value = null
              this.loading_submit = false
              this.$refs.text.$el.focus();
              sendMessageToDiscord("parent self checkout", "scan", "err invalid qr | " + temp_input);
            }

        }).catch ((err) => {
            // var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            // EventBus.$emit('OPEN_MODAL_ALERT', params)
            // this.camera_hide = true;
            error.innerHTML = "<span style='color: red;'>"+
            "Error - KIDS Not Found. Please try again </span>"
            this.camera_hide = true;
            this.form.value = null
            this.loading_submit = false
            this.$refs.text.$el.focus();
            sendMessageToDiscord("parent self checkout", "scan", "err | " + temp_input);
        })
    },
    openQueue: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 3;
        ikid.changeStatusKidForParentSelfCheckout(this.form)
        .then(res => {
        // EventBus.$emit('TABLE_UPDATE', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)
          // EventBus.$on('PAGE_RELOAD', ()=> {window.location.reload()})
          this.data = null
          this.form.value = null
          error.innerHTML = null
          this.$refs.text.$el.focus();
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },
    openCheckOut: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 4;
        ikid.changeStatusKidForParentSelfCheckout(this.form)
        .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          EventBus.$on('PAGE_RELOAD', ()=> {window.location.reload()})
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },
    openForceCheckOut: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 3;
        ikid.changeStatusKidForParentSelfCheckout(this.form)
        .then(res => {

          setTimeout(() => {
            this.form.ikid_id = uuid;
            this.form.status = 4;
            ikid.changeStatusKidForParentSelfCheckout(this.form)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE', true)
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
              EventBus.$on('PAGE_RELOAD', ()=> {window.location.reload()})
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }, 1000);


        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },

    openQueueAll: function() {
        Promise.all(
          this.selectedItems.map(i => {
          this.form.ikid_id = i;
          this.form.status = 3;
          ikid.changeStatusKidForParentSelfCheckout(this.form)
        .then(res => {
        // var params = {title: 'Success', mode:'success', data:res.message}
        // EventBus.$emit('OPEN_MODAL_ALERT', params)
        // EventBus.$emit('TABLE_UPDATE', false)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        })
      )
      .then(res => {
          this.data = []
          // EventBus.$emit('TABLE_UPDATE', true)
          this.form.value = ''
          error.innerHTML = null
          this.$refs.text.$el.focus();
          this.selectedItems = []
      })
      .catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
    })
    },

    openSelectAll:function () {
      const dataKid = this.data.filter(i => {if (i.checkin_status.action == 'in class' ) return i}).map(i => i.id)
      this.selectedItems = dataKid
    },

    getPhoto(data){
         if (data === null || data === ' '){
          return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
         }else{
          return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
         }
     },

    check123(){
      if(this.result_hide === false){
        //alert('yes');
        this.submit();
      }
    },

    changeHandler: function () {
      // if(this.form.value.length > 0){
      //   error.innerHTML = "<span'>"+
      //       "Loading...</span>"
      //   setTimeout(this.scan, 1500);

      // }

      // prevent double input on scan
      if (this.form.value.length > 0 && this.form.value.endsWith('#')) {
        this.form.value = this.form.value.slice(0, -1);
        this.loading_submit = true
        this.$refs.text.$el.blur();
        error.innerHTML = "<span'>"+
            "Loading...</span>"
        setTimeout(this.scan, 1500);

      }

    },
    messageInvalidFeedback: function(max) {
      return "Maksimal " + max + " tiket"
    },
    submit(){
      //alert('asd');
      this.loading_submit = true
      ikid.scanKidForParentPage(this.id, this.form)
      .then(res => {
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          this.camera_hide = false;
          this.result_hide = true;
          this.loading_submit = false
          this.$refs.text.$el.focus();
      }).catch ((err) => {
          this.loading_submit = false
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            this.$refs.text.$el.focus();

      })
    },

    getClassName(temp) {
        return this.class_name[this.class_id.indexOf(temp)];
    },
    getDadName(temp) {
        return this.dad_name[this.dad_id.indexOf(temp)];
    },
    getMomName(temp) {
        return this.mom_name[this.mom_id.indexOf(temp)];
    },
    clearPage() {
      this.data = []
      this.form.value = null
      error.innerHTML = null
      this.$refs.text.$el.focus();
    },
    handleSelect(data){
      if(data.checkin_status.action == 'check out' || data.checkin_status.action == 'queued' ) return
      const isExist = this.selectedItems.find(i => i === data.id)
      if(isExist){
        this.selectedItems = this.selectedItems.filter(i => i !== data.id)
      }else{
        this.selectedItems.push(data.id)
      }
    },
    isSelected(id){
      const isExist = this.selectedItems.find(i => i === id)
      return !!isExist
    },
    isDisabled(data){
      if(data && data.action){
        if(data.action === 'check out' || data.action === 'queued') return true
        return false
      }
      return false
    },
    focusTextbox() {
      if (!this.loading_submit) {
        this.$refs.text.$el.focus();
      }
    },
  }
}
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
.card-checkbox{
  width: 25px;
  height: 25px;
}
.selected {
  box-shadow: 0 0 15px #007bff;
  transition: 0.2s;
}

.disabled {
  opacity: 0.5;
}

.card-kids{
  transition: 0.3s !important;
  height: 18rem;
}
@media (min-width: 720px) {
  .buttons-row {
    bottom: 10px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }

}

</style>